import { apiOptions, apiRequest } from "../../utils";
import { API_ACCOUNT_SERVICE, ADDITIONAL_HEADERS } from "../../constants";

export const paymentTerms = {
  getAll: async () => {
    const options = await apiOptions({
      url: `${API_ACCOUNT_SERVICE}/paymentterms`,
      headers: ADDITIONAL_HEADERS,
      method: "get",
    });
    return apiRequest(options);
  },
};
